<div class="Error">

    <h2>Erro ao Cancelar o Orçamento</h2>
    <button (click)="close()">
        <span>Fechar</span>
    </button>
</div>
